module.exports = __webpack_public_path__ + "assets/img/strategy-new.e797b698.svg";